export function isDefined<T>(obj: T | null | undefined): obj is T {
  return obj !== null && obj !== undefined
}

export function maybeMap<I, O>(
  obj: I | null | undefined,
  mapFn: (o: I) => O,
): O | undefined {
  return isDefined(obj) ? mapFn(obj) : undefined
}
